module.exports = __webpack_public_path__ + "img/prize_b2.36b07af5.png";